module.exports = __webpack_public_path__ + "static/media/Element_Cryo.836ae8df.png";